
import Layout from "@/components/Layout";
import BlogPostPreview from "@/components/blog/BlogPostPreview";
import { blogPosts } from "@/data/blogPosts";

const Blog = () => {
  // Only take the first 3 blog posts
  const displayedPosts = blogPosts.slice(0, 3);

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <h1 className="text-4xl font-bold">Our Blog</h1>
          <p className="text-muted-foreground mt-2">
            Stay updated with the latest news and insights from the automotive industry
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-8">
          {displayedPosts.map((post) => (
            <div key={post.id} className="flex-1">
              <BlogPostPreview post={post} />
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default Blog;
